export const BindingType = {
	Zilliqa: Symbol.for("ZIL<Zilliqa>"),
};
